import React from "react";

import SettlementProcess from "./SettlementProcess";

const DriverAccounting = (props) => {
  return <SettlementProcess />;
};

export default DriverAccounting;
